import Vue from 'vue';

    import dayjs from 'dayjs'

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

// 获取timestampUnit, dateRange: Array[Date, Date]
// 1. 时间周期为0-21天时，趋势图颗粒度为天
// 2. 时间周期为22-63天，趋势图颗粒度为周
// 3. 时间周期为64-365天，趋势图颗粒度为月
export const getTimestampUnit = dateRange => {
  const start = dayjs(dateRange[0])
  const end = dayjs(dateRange[1])
  if (end.subtract(21, 'day').isSame(start) || end.subtract(21, 'day').isBefore(start)) {
    return 'Day'
  }
  if (end.subtract(63, 'day').isSame(start) || end.subtract(63, 'day').isBefore(start)) {
    return 'Week'
  }
  return 'Month'
}

// 数据源类型
export const XmDataSourceType = Object.freeze({
  SURVEY: {
    value: 1,
    label: $t('bb8af5'),
  },
  UPLOAD_FILE: {
    value: 2,
    label: $t('f156a9'),
  },
  MERGE_DATA: {
    value: 3,
    label: $t('6f51d3'),
  },
  OPEN_API: {
    value: 4,
    label: $t('7294e9'),
  },
  REPTILE: {
    value: 5,
    label: $t('4d39e5'),
  },
  VOICE: {
    value: 6,
    label: $t('aea420'),
  },
  IM: {
    value: 7,
    label: $t('d4ce43'),
  },
})
